export const TrendPans = {
  readytowear: [
    {
      topclass: 'free_user_plan',
      titleplan: 'Free User Plan',
      per_month: 'Free forever',
      per_year: 'Free forever',
      description:
        'Ready-to-Wear. Small accessories modelling.<br/>Modelling activities: Pockets, Collars, Sleeves, belts, etc<br/>No Design<br/>Limited access'
    },
    {
      topclass: 'user_plan',
      titleplan: 'User Plan',
      per_month: '£20',
      per_year: '£200',
      description:
        'Ready-to-Wear modelling.<br/>Modelling activities - Full modelling: Trousers, Skirts, Blazers, etc<br/>No Design<br/>Need to be creative & technical'
    },
    {
      topclass: 'user_professional_plan',
      titleplan: 'User Professional Plan',
      per_month: '£120',
      per_year: '£1,300',
      description:
        'Ready-to-Wear modelling.<br/>Modelling activities - Full modelling and Design<br/>A complete creation process with Design.<br/>Need to be creative & technical'
    }
  ],
  hautecouture: [
    {
      topclass: 'master_plan',
      titleplan: 'Mastre Plan',
      per_month: '£350',
      per_year: '£2,800',
      description:
        'Hight fashion. Haute Couture<br/>Modelling activities: Modelling and Design<br/>Creation of a evening wear collection - All process Creation<br/>Create your own fashion style<br/>Need to be creative & technical'
    }
  ]
};
